import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { PaymentsTab } from "./PaymentsTab";

interface JobPaymentsSheetProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  jobId: string;
  payments: any[];
  onPaymentsUpdate: () => void;
}

export const JobPaymentsSheet = ({
  open,
  onOpenChange,
  jobId,
  payments,
  onPaymentsUpdate,
}: JobPaymentsSheetProps) => {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="right" className="w-full sm:max-w-2xl overflow-y-auto">
        <SheetHeader>
          <SheetTitle>Payments</SheetTitle>
        </SheetHeader>
        <div className="mt-6">
          <PaymentsTab
            jobId={jobId}
            payments={payments}
            onPaymentsUpdate={onPaymentsUpdate}
          />
        </div>
      </SheetContent>
    </Sheet>
  );
};
